import { useMutation } from "@apollo/client";

import { UpdateNodeMutation, UpdateNodeMutationVariables } from "../../../API";
import { UPDATE_NODE } from "../../../common/operations/mutations";
import { handleApolloError } from "../../../common/utils/handleApolloError";

export const useUpdateNode = () => {
  const [updateNodeMutation, { loading }] = useMutation<
    UpdateNodeMutation,
    UpdateNodeMutationVariables
  >(UPDATE_NODE, { onError: handleApolloError });

  const updateNode = (input: UpdateNodeMutationVariables["input"]) =>
    updateNodeMutation({ variables: { input } });

  return { updateNode, loading };
};
